function SkeletonCard() {
  return (
    <div
      style={{
        backgroundColor: "white",
        borderRadius: 16,
        padding: 18,
        marginBottom: 14,
        border: "1px solid #f1f1f1",
        animation: "pulse 1.5s infinite",
      }}
    >
      <div
        style={{
          height: 20,
          width: "40%",
          backgroundColor: "#e5e7eb",
          borderRadius: 8,
          marginBottom: 12,
        }}
      />

      <div
        style={{
          height: 14,
          width: "60%",
          backgroundColor: "#e5e7eb",
          borderRadius: 8,
          marginBottom: 10,
        }}
      />

      <div
        style={{
          height: 14,
          width: "30%",
          backgroundColor: "#e5e7eb",
          borderRadius: 8,
        }}
      />

      <style>
        {`
          @keyframes pulse {
            0% {
              opacity: 1;
            }
            50% {
              opacity: 0.5;
            }
            100% {
              opacity: 1;
            }
          }
        `}
      </style>
    </div>
  );
}

export default SkeletonCard;